import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { APP_MENU_ROUTES, IAppMenuRoute } from '../../constants/menu-routes';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnDestroy {
  routes: ReadonlyArray<IAppMenuRoute> = APP_MENU_ROUTES.filter((route) => route.showInMenu !== false);

  currentUrl = '';
  private routeSubscription?: Subscription;

  constructor(private readonly router: Router) { }

  ngOnInit(): void {
    this.currentUrl = this.router.url;
    this.routeSubscription = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.currentUrl = event.urlAfterRedirects;
      });
  }

  ngOnDestroy(): void {
    this.routeSubscription?.unsubscribe();
  }

  isRouteActive(link: string): boolean {
    const sanitizedUrl = this.currentUrl.split('?')[0].split('#')[0];
    return sanitizedUrl === link || sanitizedUrl.startsWith(link + '/');
  }
}
